//how an order is scheduled
enum MODES {
  // used when the an Order has been created from a Tire Rack order
  // and will be completed via CS Portal
  SCHEDULER = 'scheduler',
  FINISH = 'finish',
  EDIT = 'edit',
  CUSTOMER = 'customer',
  CUSTOMER_RESCHEDULE = 'customer-reschedule',
  TR_SALES_BOOKING = 'tr-sales-booking',
}

enum ADDITIONAL_SCHEDULING_KEYS {
  INTEGRATED_SCHEDULER = 'integrated-scheduler',
  AUTO_RESCHEDULE = 'auto-reschedule',
  MISC_ROUTE_PLANNING = 'misc-route-planning',
}

//why an order is scheduled
//! Update backend types in scheduling.ts to match
export type SCHEDULING_SOURCE = MODES | ADDITIONAL_SCHEDULING_KEYS

enum SCHEDULING_KEYS {
  customerInformation = 'customer-info',
  chooseAService = 'choose-service',
  appointmentSlot = 'appointment-slots',
  paymentInformation = 'payment-information',
  confirmAppointment = 'confirm-appointment',
  appointmentConfirmation = 'appointment-confirmation',
}

const TITLES = {
  [SCHEDULING_KEYS.customerInformation]: 'Customer Information',
  [SCHEDULING_KEYS.chooseAService]: 'Choose a Service',
  [SCHEDULING_KEYS.appointmentSlot]: 'Select an Appointment Slot',
  [SCHEDULING_KEYS.paymentInformation]: 'Payment Information',
  [SCHEDULING_KEYS.confirmAppointment]: 'Confirm Appointment Information',
  [SCHEDULING_KEYS.appointmentConfirmation]: 'Thank you!',
}

export { MODES, TITLES, SCHEDULING_KEYS }
